export enum NotificationType {
  SIMPLE_NOTIFICATION = 1,
  ERROR_NOTIFICATION = 2,
  SUCCESS_NOTIFICATION = 3
}
